import type { IconData } from '@stacksjs/iconify-core'

export const mountain: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m14.846 9.334l-3.985-6.762a1 1 0 0 0-1.723 0L7.11 6.015c.202 1.979.943 2.783 2.387 2.783c2.005 0 3.816.176 5.35.536zm1.555 2.637c-1.547-.767-3.977-1.173-6.905-1.173c-1.819 0-3.11-.832-3.813-2.364l-3.57 6.058A1 1 0 0 0 2.975 16h14.05a1 1 0 0 0 .861-1.508l-1.485-2.52zM12.584 1.556l7.025 11.92A3 3 0 0 1 17.025 18H2.975A3 3 0 0 1 .39 13.477l7.025-11.92a3 3 0 0 1 5.17 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default mountain
